/* ==========================================================================
   MPACK · slapukų sutikimas

   Trys taisyklės, iš kurių išplaukia visa kita:
   1. Iki sutikimo mes patys nerašome nė vieno slapuko. Šis failas rašo tik
      `mpack_consent`, ir tik tada, kai lankytojas paspaudžia mygtuką.
   2. Sutikimas keliauja į Shopify per `customerPrivacy.setTrackingConsent`,
      kitaip mūsų juosta būtų dekoracija, o Shopify sektų toliau.
   3. Juosta niekada neuždengia lipnios mobiliosios CTA juostos: jos aukštį
      matuojame ir keliame banerį per `--mpack-cookie-lift`.
   ========================================================================== */
(function () {
  var NAME = 'mpack_consent';
  var DAYS = 395; /* 13 mėnesių */
  var VERSION = 1;

  function read() {
    var m = document.cookie.match(/(?:^|; )mpack_consent=([^;]*)/);
    if (!m) return null;
    try {
      var v = JSON.parse(decodeURIComponent(m[1]));
      return v && v.v === VERSION ? v : null;
    } catch (e) {
      return null;
    }
  }

  function write(value) {
    var d = new Date();
    d.setTime(d.getTime() + DAYS * 864e5);
    document.cookie =
      NAME +
      '=' +
      encodeURIComponent(JSON.stringify(value)) +
      '; expires=' +
      d.toUTCString() +
      '; path=/; SameSite=Lax' +
      (location.protocol === 'https:' ? '; Secure' : '');
  }

  /* Shopify sekimo sutikimas. `loadFeatures` yra vienintelis dokumentuotas
     kelias prie API, kai jos dar nėra puslapyje. */
  function mirror(consent) {
    function apply() {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent(
          {
            analytics: !!consent.a,
            marketing: !!consent.m,
            preferences: !!consent.a,
            sale_of_data: !!consent.m,
          },
          function () {}
        );
      } catch (e) {
        /* Sutikimas vis tiek išsaugotas mūsų slapuke. */
      }
    }

    if (window.Shopify && window.Shopify.customerPrivacy) return apply();
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (!err) apply();
      });
    }
  }

  function announce(consent, open) {
    document.dispatchEvent(
      new CustomEvent('mpack:consent', { detail: { consent: consent, open: open } })
    );
  }

  class MpackCookies extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.mpack-cookies__bar');
      this.panel = this.querySelector('.mpack-cookies__panel');
      this.analytics = this.querySelector('#mpack-consent-analytics');
      this.marketing = this.querySelector('#mpack-consent-marketing');

      this.addEventListener('click', this.onClick.bind(this));

      var saved = read();
      if (saved) {
        mirror(saved);
        this.hidden = true;
        announce(saved, false);
      } else {
        this.show();
      }

      this.lift();
      this.watchSticky();
      document.addEventListener('mpack:cookies-open', this.openPanel.bind(this));
    }

    onClick(event) {
      var target = event.target.closest('[data-mpack-consent]');
      if (!target) return;
      var action = target.getAttribute('data-mpack-consent');

      if (action === 'all') return this.commit({ a: 1, m: 1 });
      if (action === 'essential') return this.commit({ a: 0, m: 0 });
      if (action === 'save') {
        return this.commit({
          a: this.analytics && this.analytics.checked ? 1 : 0,
          m: this.marketing && this.marketing.checked ? 1 : 0,
        });
      }
      if (action === 'open') return this.openPanel();
      if (action === 'close') return this.panel.close();
    }

    commit(choice) {
      var value = { v: VERSION, a: choice.a, m: choice.m, t: Date.now() };
      write(value);
      mirror(value);
      if (this.panel.open) this.panel.close();
      this.hidden = true;
      announce(value, false);
    }

    show() {
      this.hidden = false;
      /* Kadras, kad `hidden` nuėmimas ir klasė nesulįstų į tą patį stilių
         perskaičiavimą: kitaip įslinkimo nesimato. */
      requestAnimationFrame(
        function () {
          this.classList.add('is-in');
        }.bind(this)
      );
      announce(null, true);
    }

    openPanel() {
      var saved = read();
      if (this.analytics) this.analytics.checked = saved ? !!saved.a : false;
      if (this.marketing) this.marketing.checked = saved ? !!saved.m : false;
      this.hidden = false;
      this.classList.add('is-in');
      if (!this.panel.open) this.panel.showModal();
    }

    /* Lipni CTA juosta (`.mpack-sticky.is-in`) yra fiksuota apačioje ir
       aukštesnė už mūsų paraštę. Pakeliame banerį tiek, kiek ji užima. */
    lift() {
      var sticky = document.querySelector('.mpack-sticky');
      var h = sticky && sticky.classList.contains('is-in') ? sticky.offsetHeight : 0;
      this.style.setProperty('--mpack-cookie-lift', h + 'px');
    }

    watchSticky() {
      var sticky = document.querySelector('.mpack-sticky');
      if (!sticky) return;
      var relift = this.lift.bind(this);
      if (window.MutationObserver) {
        this._mo = new MutationObserver(relift);
        this._mo.observe(sticky, { attributes: true, attributeFilter: ['class', 'hidden'] });
      }
      if (window.ResizeObserver) {
        this._ro = new ResizeObserver(relift);
        this._ro.observe(sticky);
      }
    }

    disconnectedCallback() {
      if (this._mo) this._mo.disconnect();
      if (this._ro) this._ro.disconnect();
    }
  }

  if (!customElements.get('mpack-cookies')) {
    customElements.define('mpack-cookies', MpackCookies);
  }

  /* Footer'io nuoroda: viena vieta, kur skydelį galima atidaryti bet kada. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-mpack-cookies-open]');
    if (!link) return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('mpack:cookies-open'));
  });
})();
